<template>
  <HubContainer id="helpSupportHub">

    <template v-if="atLeastCompanyAdmin && !$store.getters.isBranchContextInventory">
      <HubSection large icon="icon/hub/support-contact.svg" id="supportSection"
                  :title="$t('support_phone')"
                  :description="`<a href='tel:+18888006622'>1-888-800-6622</a>`"
                  :buttonAction="() => {}">
      </HubSection>

      <HubSection large icon="icon/hub/knowledge-base.svg"
                  :title="$t('advanced_navigation.faq')"
                  :description="$t('advanced_navigation.faq_description')"
                  :buttonAction="goToFaq">
      </HubSection>

      <HubSection large icon="icon/hub/commands.svg"
                  :title="$t('advanced_navigation.training')"
                  :description="$t('advanced_navigation.training_description')"
                  :buttonAction="goToTraining">
      </HubSection>

      <HubSection large icon="icon/hub/support-tools.svg" v-if="company"
                  :title="$t('POS')"
                  :description="$t('advanced_navigation.training_description')"
                  :buttonAction="goToPosSupportHub">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "helpSupportHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.help_support";
      this.$store.state.pageIcon = "/icon/info.svg";
    },

    data() {
      return {
        Parameters
      }
    },

    computed: {
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      company() {
        return this.$store.state.contextCompany;
      }
    },

    methods: {
      goToFaq() {
        window.open(this.$to(this.Parameters.urlSupport));
      },
      goToTraining() {
        this.$router.push(this.$router.buildContext("/training"));
      },
      goToPosSupportHub() {
        this.$router.push(this.$router.buildContext("/pos-help-support-hub"));
      },
    }
  }
</script>

<style lang="scss">
  #helpSupportHub #supportSection {
    .btn {
      display: none;
    }
    .hub-section__description {
      font-weight: bold;
      font-size: 20px;
    }

  }
</style>